import { useState } from 'react'
import { DateTime } from 'luxon'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { UploadDocumentType } from '@/constants/businessConstants'
import { UserDocumentCategoryIdentifier } from '@/features/admin/user-document-categories/userDocumentCategory.constants'

import { UploadItem } from './UploadItem'

import { Popup, Text, DatePicker } from '@/ui'
import { selectCurrentAnnualTaxYear } from '@/features/admin/annual-tax-details/annualTaxDetails.selector'
import { useReselector } from '@/utils/sharedHooks'
import {
  selectUserDocumentCategory,
  selectUserDocumentCategoryByInternalName,
} from '@/features/admin/user-document-categories/userDocumentCategories.selectors'

export const PriorYearTaxReturnUploadItem = ({
  uploadButtonOnly,
}: {
  uploadButtonOnly?: boolean
}) => {
  const taxYear = DateTime.now().year
  const [year, setYear] = useState(taxYear.toString())
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)
  const nextTaxYear = (Number(currentTaxYear) + 1).toString()
  const taxDocCat = useReselector(
    selectUserDocumentCategoryByInternalName,
    UserDocumentCategoryIdentifier.finalReturn
  )
  const sentCategory = useReselector(selectUserDocumentCategory, taxDocCat?.id)

  return (
    <UploadItem
      label="Prior Year Tax Return"
      documentCategory={UserDocumentCategoryIdentifier.finalReturn}
      uploadProps={{ year: year.toString() }}
      additionalTrackingProperties={{
        document_category: UploadDocumentType.TAX,
        document_name: sentCategory?.title || '',
        tax_year: Number(year),
      }}
      uploadButtonOnly={uploadButtonOnly}
    >
      <Text>This is your Federal and/or State Tax Return(s).</Text>

      <DatePicker
        placeholder="Select year"
        label="Tax Year"
        value={year?.toString() ?? ''}
        maxDate={new Date()}
        onChange={setYear}
        dateFormat={DATE_FORMATS_LUXON.YEAR_FOUR_DIGIT}
        showYearPicker
        clearable
        afterLabel={
          <Popup
            content={
              <Text>
                A tax year is the 12-month calendar year covered by a tax
                return. In the U.S., the tax year for individuals runs from Jan.
                1 to Dec. 31 and includes taxes owed on earnings during that
                period. For example, taxes withheld or owed for earnings during
                the calendar year {currentTaxYear} would be included on the tax
                return sent to the IRS in {nextTaxYear}. Even though you are
                sending the tax return in {nextTaxYear}, it is for the tax year{' '}
                {currentTaxYear}.
              </Text>
            }
          />
        }
      />
    </UploadItem>
  )
}
